import { Comment,OperationLog} from '@/common/model';
import { registerMock } from '@/utils/mockRegistry'; 
import { Project } from './model';
import { Demand } from '../demand/model';
import mockDemandList from '../demand/mock';
const projects: Project[] = [
    {
        id: 1,
        name: "Project 1",
        content: "Content of Project 1",
        submitterId: 101,
        submitterName: "John Doe",
        businessId:3,
        businessName:'电商业务',
        docLink:"http://www.baidu.com",
        directorId: 201,
        directorName: "Alice Smith",
        submitTime: new Date("2024-06-01"),
        finishTime: new Date("2024-07-01"),
        status: 1,
        demands: [
            {
                id: 1,
                content: "Demand 1 for Project 1",
                submitTime: new Date("2024-06-02"),
                submitterId: 101,
                executorId: 201,
                status: 1
            },
            {
                id: 2,
                content: "Demand 2 for Project 1",
                submitTime: new Date("2024-06-05"),
                submitterId: 101,
                executorId: 202,
                status: 2
            }
        ],
        deliveries: [
            {
                id: 1,
                name: "Delivery 1 for Project 1",
                finishDate: "2024-06-20",
                createTime: "2024-06-18 12:00:00",
                submitterId: 201,
                members: [201, 202, 203],
                taskStatusId: 1,
                taskStatusName: "TaskName",
                taskScaleType: 0,
                projectId: 1,
                projectName: 'Project 1',
                taskTypeId: 0,
                morningMeetingId: 0,
                attachmentUrl: '',
                remarks: '',
                lastOperator: 1,
                updateTime: ''
            }
        ],
        comments: [
            {
                id: 1,
                content: "Comment 1 for Project 1",
                fromUserId: 5,
                fromUserName: "John Doe",
                toUserid: 201,
                toUserName: "Alice Smith",
                replyToId: null,
                createTime: new Date("2024-06-10"),
                updateTime: new Date("2024-06-11")
            }
        ],
        logs: [
            {
                id: 1,
                operatorId: 101,
                operatorName: "John Doe",
                content: "Created Project 1",
                logTime: new Date("2024-06-01")
            }
        ]
    },
    {
        id: 2,
        name: "Project 2",
        content: "Content of Project 2",
        businessId:3,
        businessName:'电商业务',
        docLink:"http://www.baidu.com",
        submitterId: 102,
        submitterName: "Jane Smith",
        directorId: 202,
        directorName: "Bob Johnson",
        submitTime: new Date("2024-06-05"),
        finishTime: new Date("2024-07-05"),
        status: 2,
        demands: [],
        deliveries: [],
        comments: [],
        logs: []
    },
    {
        id: 3,
        name: "Project 3",
        content: "Content of Project 3",
        businessId:3,
        businessName:'电商业务',
        submitterId: 103,
        docLink:"http://www.baidu.com",
        submitterName: "Emily Brown",
        directorId: 203,
        directorName: "David Lee",
        submitTime: new Date("2024-06-10"),
        finishTime: new Date("2024-07-10"),
        status: 1,
        demands: [],
        deliveries: [],
        comments: [],
        logs: []
    },
    {
        id: 4,
        name: "Project 4",
        content: "Content of Project 4",
        businessId:3,
        businessName:'电商业务',
        submitterId: 104,
        submitterName: "Michael Green",
        docLink:"http://www.baidu.com",
        directorId: 204,
        directorName: "Sophia White",
        submitTime: new Date("2024-06-15"),
        finishTime: new Date("2024-07-15"),
        status: 2,
        demands: [],
        deliveries: [],
        comments: [],
        logs: []
    },
    {
        id: 5,
        name: "Project 5",
        content: "Content of Project 5",
        businessId:3,
        businessName:'电商业务',
        submitterId: 105,
        docLink:"http://www.baidu.com",
        submitterName: "William Black",
        directorId: 205,
        directorName: "Olivia Davis",
        submitTime: new Date("2024-06-20"),
        finishTime: new Date("2024-07-20"),
        status: 1,
        demands: [],
        deliveries: [],
        comments: [],
        logs: []
    }
];

const mockComments: Comment[] = [
    {
      id: 1,
      content: '这个需求很紧急，需要尽快处理。',
      fromUserId: 5,
      fromUserName: '罗炳',
      toUserid: 2,
      toUserName: '李四',
      replyToId: 0,
      createTime: new Date('2023-06-10T10:20:30Z'),
      updateTime: new Date('2023-06-10T10:20:30Z')
    },
    {
      id: 2,
      content: '已经完成了第一部分。',
      fromUserId: 5,
      fromUserName: '罗炳',
      toUserid: 1,
      toUserName: '张三',
      replyToId: 1,
      createTime: new Date('2023-06-12T14:30:45Z'),
      updateTime: new Date('2023-06-12T14:30:45Z')
    }
  ];



export const registerMocks = ()=>{
    registerMock("projectList", projects);
    registerMock("demandList", mockDemandList);
}